import React from 'react';
import { Tag } from 'antd';

// Reusable status pill. Maps a domain status string onto a SEMANTIC Ant Tag colour
// (success/warning/error/default), which resolves to the KaziPeople status tokens via
// the Ant baseToken in main.tsx (#16A34A / #D97706 / #DC2626). Use this instead of
// hardcoding Ant palette hexes (#52c41a / #faad14 / #ff4d4f) so status colour stays
// consistent across the console. See docs/admin-platform-operations-console-design.md §13.

const SUCCESS = new Set([
  'active', 'success', 'succeeded', 'paid', 'completed', 'approved', 'enabled', 'up',
  'verified', 'delivered', 'activated', 'healthy', 'operational', 'reconciled', 'trialing',
]);
const WARNING = new Set([
  'pending', 'processing', 'submitting', 'trial', 'review', 'pending_review', 'partner_review',
  'draft', 'warning', 'submitted', 'awaiting', 'past_due', 'paused', 'suspended', 'degraded',
]);
const DANGER = new Set([
  'failed', 'error', 'disabled', 'rejected', 'down', 'terminated', 'expired', 'blocked',
  'dead', 'cancelled', 'void', 'defaulted', 'critical', 'major_outage',
]);
const NEUTRAL = new Set(['inactive', 'unknown', 'not_granted', 'none', 'n/a', 'pending_setup']);

/** Semantic Ant Tag colour for a status string. */
export const statusColor = (status?: string): string => {
  const s = (status || '').toLowerCase().trim();
  if (SUCCESS.has(s)) return 'success';
  if (WARNING.has(s)) return 'warning';
  if (DANGER.has(s)) return 'error';
  if (NEUTRAL.has(s)) return 'default';
  return 'default';
};

export const StatusTag: React.FC<{ status?: string; label?: string }> = ({ status, label }) => (
  <Tag color={statusColor(status)}>
    {(label ?? status ?? '—').toString().replace(/_/g, ' ').toUpperCase()}
  </Tag>
);

export default StatusTag;
